/*
 * @Author: Victor
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Gaho
 * @LastEditTime: 2024-05-15 15:45:20
 * @Description:
 */

import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const useDice = (rootPath) => {
    const EMIT_DICE_BET = async (
        data: {
            is_under: boolean;
            prediction: number;
            amount: string;
            isFast: boolean;
            frontID: number;
            strategyName: string;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            response: {
                roll_number: string;
                winAmount: number;
                [key: string]: any; // 前端将追加其它值
            };
        }>(`${rootPath}.dice.bet`, data);
    };

    return {
        EMIT_DICE_BET,
    };
};
